import jhsfBookingsApi from '../apis/jhsfBookingsApi';

const deleteActivitiesService = async (activityId: string): Promise<void> => {
  await jhsfBookingsApi.delete(`/activities/${activityId}`);
};

export default deleteActivitiesService;
